export default __webpack_public_path__ + "static/footer-logo-1ec4019b732af2784a60b889f01591f8.svg";